const feePaymentTypeOptions = [
  { id: 'credit', name: 'Tarjeta de crédito' },
  { id: 'debit', name: 'Tarjeta de débito' },
  { id: 'transfer', name: 'Transferencia' },
  { id: 'check', name: 'Cheque' },
  { id: 'monthly', name: 'Pago en sucursal' },
];

export default feePaymentTypeOptions;
